import {format, parseISO, intervalToDuration} from 'date-fns'
import {dateFormats} from '../../editable-stuff/constants'

export function getExperienceDate(startDateIso, endDateIso) {
    const start = parseISO(startDateIso)
    const end = endDateIso ? parseISO(endDateIso) : new Date()

    const formattedStart = format(start, dateFormats.dayMonthYear)
    const formattedEnd = endDateIso
        ? format(end, dateFormats.dayMonthYear)
        : 'Present'

    const {years, months} = intervalToDuration({start, end})

    let duration = ''

    if (years > 0) {
        duration += `${years} year${years > 1 ? 's' : ''}`
    }

    if (months > 0) {
        if (duration) duration += ' - '
        duration += `${months} month${months > 1 ? 's' : ''}`
    }

    if (!duration) {
        duration = '0 months'
    }

    return {
        formattedEnd,
        formattedStart,
        duration
    }
}